/* eslint-disable */

// MARK: TypeDefinitions & Constants

import {dbgprintf} from "./utils";
import {ESDIconPackParser} from './ESDIconPackParser.js';

const PLUGIN_EXTENSION = ".sdPlugin";
const PLUGIN_ARCHIVE_EXTENSION = ".streamDeckPlugin";

const ICON_PACK_EXTENSION = ".sdIconPack";
const ICON_PACK_ARCHIVE_EXTENSION = ".streamDeckIconPack";

/// #if SD_DISTRIBUTION_TOOL_SUPPORT_UPLOAD
// const PLUGIN_STORE_URL = ""; // old appstoreconnect.elgato.com
// const ICON_PACK_STORE_URL = ""; // old appstoreconnect.elgato.com
//#endif

const kESDObjectType_Plugin = 0;
const kESDObjectType_IconPack = 1;

const ESDObjectType = {
    kESDObjectType_Plugin,
    kESDObjectType_IconPack
};

const kESDIconPackSupportedResult_Supported = 0;
const kESDIconPackSupportedResult_Malformed = 1;
const kESDIconPackSupportedResult_AlreadyInstalled = 2;

const ESDIconPackSupportedResult = {
    kESDIconPackSupportedResult_Supported,
    kESDIconPackSupportedResult_Malformed,
    kESDIconPackSupportedResult_AlreadyInstalled,
};

const NULL = null;
const _UP_WINDOWS = false;
const MAX_PATH = 260;
const LONG_PATH_PREFIX = "\\\\?\\";
const npos = -1;

const debug = false;

String.prototype.find = String.prototype.indexOf;
// String.prototype.find_last_of = String.prototype.lastIndexOf;

String.prototype.rfind = String.prototype.lastIndexOf;
String.prototype.empty = function() {return !this.length;};
String.prototype.c_str = function() {return this.toString();};

// // eslint-disable-next-line no-unused-vars;
// const sprintf = (s, ...args) => {
//     let i = 0;
//     return s.replace(/%s|%d/g, function() {
//         return args[i++];
//     });
// };
// // const empty = (inString = '') => {
// //     return inString.length < 1;
// // };

const createErrorMessage = (e) => {
    if(typeof e === 'object') {
        // if(e instanceof FileSystemFileEntry) {
        // if(e instanceof FileSystemEntry) {
        if(e.fullPath) {
            return e.fullPath.substr(1);
        } else if(e instanceof Error) {
            return `${e.name}: ${e.message}`;
        }
    }
    return e;
};


export function EplFile_GetPathDelimiter() {
    return '/';
    // return '\\';  // Windows
}

// MARK: - Plugin vs icon-pack

export function GetArchiveExtension(inObjectType) {

    switch(inObjectType) {
        case kESDObjectType_Plugin:
            return PLUGIN_ARCHIVE_EXTENSION;
            break;

        case kESDObjectType_IconPack:
            return ICON_PACK_ARCHIVE_EXTENSION;
            break;

        default:
            dbgprintf("Error: Unknown archive extension for object %d.", inObjectType);
            return "";
            break;
    }
}

export function GetExtension(inObjectType) {
    switch(inObjectType) {
        case kESDObjectType_Plugin:
            return PLUGIN_EXTENSION;
            break;

        case kESDObjectType_IconPack:
            return ICON_PACK_EXTENSION;
            break;

        default:
            dbgprintf("Error: Unknown extension for object %d.", inObjectType);
            return "";
            break;
    }
}

export function GetDebugTerm(inObjectType) {
    switch(inObjectType) {
        case kESDObjectType_Plugin:
            return "plugin";
            break;

        case kESDObjectType_IconPack:
            return "icon pack";
            break;

        default:
            dbgprintf("Error: Unknown debug term for object %d.", inObjectType);
            return "";
            break;
    }
}

// export function GetDefaultServerStore(inObjectType) {
//     switch(inObjectType) {
//         case kESDObjectType_Plugin:
//             return PLUGIN_STORE_URL;
//             break;

//         case kESDObjectType_IconPack:
//             return ICON_PACK_STORE_URL;
//             break;

//         default:
//             dbgprintf("Error: Unknown default server for object %d.", inObjectType);
//             return "";
//             break;
//     }
// }

export function Validate(inObjectType, inPath) {
    switch(inObjectType) {
        case kESDObjectType_Plugin:
            return ValidatePlugin(inPath);
            break;

        case kESDObjectType_IconPack:
            return ValidateIconPack(inPath);
            break;

        default:
            dbgprintf("Error: Can't validate object %d.", inObjectType);
            return false;
            break;
    }
}

// export function doesFileExist(urlToFile) {
//     var xhr = new XMLHttpRequest();
//     xhr.open('HEAD', urlToFile, false);
//     xhr.send();

//     if(xhr.status == "404") {
//         return false;
//     } else {
//         return true;
//     }
// }

export function EplFile_FileExists(inUtf8FilePath) {
    return new Promise((resolve, reject) => {
        let req = new XMLHttpRequest();
        let privateErrorFlag = false;
        req.open("HEAD", inUtf8FilePath);
        ['onabort', 'onerror', 'ontimeout'].map(e => {
            req[e] = (err) => {
                console.log(inUtf8FilePath, '*********** ERRÖR', err);
                privateErrorFlag = true;
                req.abort();
                resolve(false);
            };
        });

        ['onload', 'onloadend'].map(e => {
            req[e] = (evt) => {
                resolve(!privateErrorFlag);
            };
        });

        req.onreadystatechange = () => {
            if(req.readyState === 4) {
                // console.log('READYSTATE 4:', req.status, req.readyState);
                if(req.status >= 200 && req.status < 300) {
                    resolve(true);
                } else if(req.status == 404) {
                    resolve(false);
                }
            }

        };
        req.send(null);
    });
}

export function EplString_HasPrefix(inString, inPrefix) {
    return (inString.length >= inPrefix.length) && (inString.startsWith(inPrefix));
}

export function EplString_HasSuffix(inString, inSuffix) {
    return (inString.length >= inSuffix.length) && (inString.endsWith(inSuffix));
}

export function EplString_Contains(inString, inSubString) {
    return (inString.length >= inSubString.length) && (inString.includes(inSubString));
}

export function EplFile_AddPathComponent(inPath, inComponentToAdd) {
    if(inPath.empty())
        return inComponentToAdd;

    const delimiter = EplFile_GetPathDelimiter();
    const lastChar = inPath[inPath.length - 1];

    const pathEndsWithDelimiter = lastChar == delimiter || lastChar == '/';

    const firstChar = inComponentToAdd.charAt(0);
    const compStartsWithDelimiter = firstChar == delimiter || firstChar == '/';

    let result = '';
    if(pathEndsWithDelimiter && compStartsWithDelimiter)// deal with "foo/" "/index.html" ?
        result = inPath + inComponentToAdd.substr(1);
    else if(pathEndsWithDelimiter || compStartsWithDelimiter)
        result = inPath + inComponentToAdd;
    else
        result = inPath + delimiter + inComponentToAdd;

    if(_UP_WINDOWS) {
        // make sure we use the default delimiter
        result.replaceAll('/', delimiter);

        result = EplFile_GetLongPathWithPrefix(result);
    }

    return result;
}

// use Javascript style inPath and ensure returned path has no trailing delimiter
export function EplFile_GetFileName(inPath) {

    if(inPath.empty()) {
        return inPath;
    }
    const delimiterString = EplFile_GetPathDelimiter();
    //
    // Remove the trailing delimiters
    //
    let pathWithoutTrailingDelimiter = inPath;
    while(pathWithoutTrailingDelimiter.length > delimiterString.length && EplString_HasSuffix(pathWithoutTrailingDelimiter, delimiterString)) {
        pathWithoutTrailingDelimiter = pathWithoutTrailingDelimiter.substr(0, pathWithoutTrailingDelimiter.length - delimiterString.length);
    }
    //
    // Special cases
    //
    if(pathWithoutTrailingDelimiter.empty() || pathWithoutTrailingDelimiter == delimiterString) {
        return delimiterString;
    }
    // Get the last path component
    //
    const pos = pathWithoutTrailingDelimiter.lastIndexOf(delimiterString);
    if(npos != pos && pathWithoutTrailingDelimiter.length > pos) {
        return pathWithoutTrailingDelimiter.substr(pos + 1);
    }
    // return inPath.replace(/\/?$/, '/');
    return pathWithoutTrailingDelimiter;
}

export function EplFile_GetExtension(inPath) {
    const fileName = EplFile_GetFileName(inPath);
    const pos = fileName.lastIndexOf(".");
    if(npos != pos && ((pos + 1) != fileName.length)) {
        return fileName.substr(pos);
    } else {
        return "";
    }
    //
    // Fallback
    //
    return pathWithoutTrailingDelimiter;
}


// See Microsoft documentation:
// https://msdn.microsoft.com/en-us/library/windows/desktop/aa365247(v=vs.85).aspx
//
// To specify an extended-length path, use the "\\?\" prefix.
//
// When using an API to create a directory, the specified path cannot be so long
// that you cannot append an 8.3 file name (that is, the directory name cannot exceed MAX_PATH minus 12).
//
export function EplFile_GetLongPathWithPrefix(inPath) {
    if(_UP_WINDOWS) {
        if(inPath.length < MAX_PATH - 12)
            return inPath;
        if(inPath.rfind(LONG_PATH_PREFIX) == 0)
            return inPath;
        if(inPath.rfind(LONG_PATH_PREFIX) != npos && inPath.rfind(LONG_PATH_PREFIX) > 0)
            return inPath.substr(inPath.rfind(LONG_PATH_PREFIX));
        return LONG_PATH_PREFIX + inPath;

    } else {
        return inPath;
    };
}


/**
 Get the filename from the full path

 @param inPath Plugin or icon pack path
 @return filename
 */

export function GetFilenameFromFilePath(inPath) {
    let outFilename = inPath;

    if(EplString_HasSuffix(inPath, PLUGIN_EXTENSION) || EplString_HasSuffix(inPath, ICON_PACK_EXTENSION)) {
        const lastindex = inPath.lastIndexOf(".");
        const pathWithNoExtension = inPath.substr(0, lastindex);

        const lastPathDelimiterIndex = pathWithNoExtension.lastIndexOf(EplFile_GetPathDelimiter());
        outFilename = inPath.substr(lastPathDelimiterIndex + 1, pathWithNoExtension.length - lastPathDelimiterIndex - 1);
    }

    return outFilename;
}

/**
 Get the UUID from the full path

 @param inPath Plugin or icon pack path
 @return UUID
 */
export function GetUUIDFromFilePath(inPath) {
    return GetFilenameFromFilePath(inPath);
}

/**
 Get the manifest.json path for a .sdPlugin or .sdIconPack path

 @param inPath .sdPlugin or .sdIconPack path
 @return manifest.json path
 */
export function GetManifestFromFilePath(inPath) {
    return EplFile_AddPathComponent(inPath, "manifest.json");
}

export function GetManifestFromFilePathJS(inObj, inComponent) {
    return GetPathForComponent(inObj, 'manifest.json');
}

export function GetPathForComponent(inObj, inComponent) {
    return GetFolderContents(inObj).then(entries => {
        return entries.find(e => !e.isDirectory && (e.name == inComponent)) || null;
    });
}


export function GetFolderContents(inObj, onlyFiles = false) {
    return new Promise((resolve) => {
        if(!inObj) {
            return resolve([]);
        }
        const directoryReader = inObj.createReader();
        let arrEntries = [];
        const readFolderEntries = () => {
            directoryReader.readEntries((entries) => { // readEntries() must be called until it returns an empty array.
                if(!entries.length) {
                    if(onlyFiles) arrEntries = arrEntries.filter(ae => ae.file);
                    resolve(arrEntries);
                } else {
                    // strip invisible characters and file with double underscore
                    // Chrome shows invisible files, Safari not
                    arrEntries.push(...entries.filter(e => !/^(\.)/gi.test(e.name)));
                    readFolderEntries();
                }
            }, (err) => {
                console.log("GetFolderContents::ERROR", inObj);
            });
        };
        readFolderEntries();
    });
}

export function GetFolder(inObj, folderName) {
    const directoryReader = inObj.createReader();
    return new Promise((resolve, reject) => {
        return directoryReader.readEntries((entries) => {
            resolve(entries.find(e => e.isDirectory && e.name.toLowerCase() == folderName));
        });
    }).then(d => {
        return d;
    });
}

export function IsValidURI(inURIString) {
    if(inURIString.empty()) {
        return false;
    }
    else {
        let isValidURI = true;
        let previousChar = 0;
        for(let c of inURIString) {
            if(previousChar == '.' && c == '.') {
                // Plugin contains '..'
                isValidURI = false;
                break;
            }
            else if(c == '.' || c == '-' || (c >= 'a' && c <= 'z') || (c >= '0' && c <= '9')) {
                // OK
                previousChar = c;
            }
            else {
                isValidURI = false;
                break;
            }
        }

        return isValidURI;
    }
}

export function IsValidPath(inPath) {
    if(inPath.find("/./") != npos) {
        return false;
    }

    if(inPath.find("/../") != npos) {
        return false;
    }

    return true;
}

export function IsValidVersion(inVersion) {
    if(inVersion.empty()) {
        return true;
    }

    let isvalid = true;
    // for(auto character = inVersion.cbegin();character != inVersion.cend(); ++character)
    for(let character of inVersion) {
        if(character >= '0' && character <= '9') {
            continue;
        }
        else if((character) == '.') {
            continue;
        }
        else {
            isvalid = false;
        }
    }

    return isvalid;
}

export function IsValidUUID(inUUID) {
    // const reverseDNSRegEx = "^[A-Za-z]{2,6}((?!-)\\.[A-Za-z0-9-]{1,63}(?<!-))+$"; // <- doesn't work in Safari
    // const reverseDNSRegEx1 = "^[A-Za-z]{2,6}((?!-)\\.[A-Za-z0-9-]{1,63})+$"; // <- works in Safari
    // const r1 = new RegExp(reverseDNSRegEx1);
    // console.log("reverseDNSRegEx1:", inUUID, r1.test(inUUID));

    // const reverseDNSRegEx2 = "^[a-z]{2,6}((?!-)\\.[a-z0-9-]{1,63})+$"; // <- works in Safari
    // const r2 = new RegExp(reverseDNSRegEx2);
    // console.log("reverseDNSRegEx2:", inUUID, r2.test(inUUID));
    // since 2025-11-21
    const reverseDNSRegEx = "^([a-z0-9-]+)(\.[a-z0-9-]+)+$";
    const r = new RegExp(reverseDNSRegEx);
    // console.log("reverseDNSRegEx:", inUUID, r.test(inUUID));
    return r.test(inUUID);
}

export function isInPath(parent, child) {
    if(child === parent) return false;
    const parents = parent.split('/').filter(i => i.length);
    return parents.every((t, i) => child.split('/')[i] === t);
}

// MARK: Validate Plugin

export function ValidatePlugin(inPath) {
    // tbd
}

// export function CheckFilesFromFolderExistInIconsJson(inFolderPath, inSubFolderPath, inAllKnownFiles) {
//     // tbd
//     console.log("+++++++++++++++++ CheckFilesFromFolderExistInIconsJson +++andy missing");
//     const allFilesInFolder = [];
//     if(EplFile_EnumFilesInFolder(inFolderPath, allFilesInFolder, true)) {
//         for(const filename of allFilesInFolder) {
//             // EplFile_EnumFilesInFolder incorrectly returns "." and ".."
//             // Also if inIncludeSubdirectories is true, it only returns subfolders and not the files inside a subfolder
//             if(filename == "." || filename == "..")
//                 continue;

//             const iconPath = EplFile_AddPathComponent(inFolderPath, filename);
//             if(EplFile_FolderExists(iconPath)) {
//                 const completeSubFolder = EplFile_AddPathComponent(inSubFolderPath, filename);
//                 if(!CheckFilesFromFolderExistInIconsJson(iconPath, completeSubFolder, inAllKnownFiles)) {
//                     return false;
//                 }
//             } else {
//                 const completeFileName = EplFile_AddPathComponent(inSubFolderPath, filename);
//                 //  tbd +++andy
//                 // andy stop here;
//                 // auto IT = std:: find(inAllKnownFiles.begin(), inAllKnownFiles.end(), completeFileName);
//                 // if(IT == inAllKnownFiles.end()) {
//                 //     // Ignore png file if there is a gif file
//                 //     if(EplFile_GetExtension(filename) == ".png") {
//                 //         const completeGIFFileName = EplFile_SetExtension(completeFileName, ".gif");
//                 //         const completeGIFPath = EplFile_AddPathComponent(inFolderPath, completeGIFFileName);
//                 //         if(EplFile_FileExists(completeGIFPath)) {
//                 //             continue;
//                 //         }
//                 //     }

//                 //     dbgprintf("Error: The file '%s' has no entry in the icons.json file.", completeFileName.c_str());
//                 //     return false;
//                 // }
//             }
//         }
//     }


//     return true;
// };

// MARK: Validate Icon Pack

export function resolveAfter2Seconds(x) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(x);
        }, 2000);
    });
}

export async function ValidateIconPack(inPath) {
    return new Promise((resolve) => {
        ValidateIconPackAsync(inPath).then(success => {
            resolve(success);
        });
    });
};

async function ValidateIconPackAsync(inPathMulti) {

    try {

        const getFileFromFileEntry = (entry) => {
            return new Promise((resolve) => {
                entry.file((file) => {
                    // resolve(this.packageFile(file, entry));
                    // resolve(file, entry);
                    resolve({
                        file,
                        entry,
                        objectURL: URL.createObjectURL(file),
                        fullPath: `${entry.fullPath}`.slice(1)
                    });
                });
            });
        };

        const isFileObject = typeof inPathMulti === 'object';
        let inPath = isFileObject ? inPathMulti.name : inPathMulti;

        const iconPackFiles = isFileObject ? await GetFolderContents(inPathMulti) : [];
        const iconPackIconsFolder = isFileObject ? iconPackFiles.find(e => e.isDirectory && e.name.toLowerCase() == 'icons') : [];
        const iconsFiles = isFileObject ? await GetFolderContents(iconPackIconsFolder) : [];
        const previewImagesFolder = isFileObject ? iconPackFiles.find(e => e.isDirectory && e.name.toLowerCase() == 'previews') : [];
        const previewFiles = previewImagesFolder ? await GetFolderContents(previewImagesFolder) : [];

        // console.log("****PREVIEWS ", previewImagesFolder, previewFiles);
        previewFiles.forEach(f => {
            if(f.file) {
                getFileFromFileEntry(f).then(file => {
                    console.log(file.file.name, file);
                });
            }
        });

        const Folder_FileExists = (folder, fileName) => {
            const found = folder.find(e => e.isFile && (e.name == fileName));
            if(!found) {
                folder.sort((a, b) => a.name > b.name);
                console.log("---- file not found", fileName, folder);
                // console.log("Folder_FileExists", e.name, e);
            }
            return found;
        };

        // const Folder_FileExists = (folder, fileName) => folder.find(e => e.isFile && (e.name == fileName));

        dbgprintf(`Validating iconpack:  ${inPath}`);
        if(!EplString_HasSuffix(inPath, ICON_PACK_EXTENSION)) {
            dbgprintf("Error: The icon pack should have the extension .sdIconPack.");
            return false;
        }

        const filename = GetFilenameFromFilePath(inPath);
        if(filename.empty()) {
            dbgprintf("Error: The icon pack could not be found on disk.");
            return false;
        }

        const uuid = GetUUIDFromFilePath(inPath);
        if(uuid.empty()) {
            dbgprintf("Error: The icon pack has an invalid UUID '%s'. Please rename the %s folder to a valid uniform type identifier (UTI) that contains only alphanumeric characters (A-Z, a-z, 0-9), hyphen (-), and period (.).", filename.c_str(), ICON_PACK_EXTENSION);
            return false;
        }

        const manifestPath = isFileObject ? await GetManifestFromFilePathJS(inPathMulti) : GetManifestFromFilePath(inPath);
        if(!manifestPath) {
            if(!await EplFile_FileExists(manifestPath)) {
                dbgprintf("Error: The icon pack has no manifest.json file.");
                return false;
            }
        }

        const debugTerm = GetDebugTerm(kESDObjectType_IconPack);
        const supportedResult = {result: kESDIconPackSupportedResult_Supported};
        const iconPack = await ESDIconPackParser.CreateIconPackFromPath(uuid, inPath, manifestPath, supportedResult, inPathMulti);

        if(iconPack == NULL) {
            dbgprintf("Error: The manifest.json file doesn't contain a valid json.");
            return false;
        }

        if(iconPack.GetVersion().empty()) {
            dbgprintf("Error: The %s has an invalid version. Please add a valid \"Version\" property to the manifest.json file.", debugTerm);
            return false;
        }

        if(!IsValidVersion(iconPack.GetVersion())) {
            dbgprintf("Error: The %s has an invalid version '%s'. Please add a valid \"Version\" property to the manifest.json file.", iconPack.GetVersion(), debugTerm);
            return false;
        }

        if(iconPack.GetName().empty()) {
            dbgprintf("Error: The %s has an invalid name. Please add a valid \"Name\" property to the manifest.json.", debugTerm);
            return false;
        }

        if(iconPack.GetAuthor().empty()) {
            dbgprintf("Error: The %s has an invalid author. Please add a valid \"Author\" property to the manifest.json.", debugTerm);
            return false;
        }

        const iconURL = iconPack.GetURL();
        if(!iconURL.empty()) {
            if(!EplString_HasPrefix(iconURL, "https://") && !EplString_HasPrefix(iconURL, "http://")) {
                dbgprintf("Error: The %s has an invalid url '%s'. The \"URL\" property in the manifest.json should use an http(s) scheme.", debugTerm, iconURL);
                return false;
            }
        }

        if(iconPack.GetUUID().empty() || !IsValidURI(iconPack.GetUUID())) {
            dbgprintf("Error: The %s has an invalid UUID '%s'. Please rename the %s folder to a valid uniform type identifier (UTI) that contains only lowercase alphanumeric characters (a-z, 0-9), hyphen (-), and period (.).", debugTerm, iconPack.GetUUID(), ICON_PACK_EXTENSION);
            return false;
        }

        // Validate icon
        const icon = iconPack.GetIconFullPath();
 
        if(icon.empty()) {
            dbgprintf("Error: The %s has an invalid icon. Please add a valid \"Icon\" property to the manifest.json.", debugTerm);
            return false;
        }

        const iconPath = iconPack.GetIcon();
        let iconExists = false;
        if(iconPath.includes("/")) {
            iconExists = isInPath(inPathMulti.fullPath, icon) && await utils.getFileFromFileEntryP(inPathMulti, iconPath);
        } else {
            iconExists = isFileObject ? await GetPathForComponent(inPathMulti, iconPath) != null : await EplFile_FileExists(icon);
        }
        
        if(!iconExists) {
            // if(!await EplFile_FileExists(icon)) {
            dbgprintf("Error: The %s has an icon \"%s\" that does not exist.", debugTerm, EplFile_GetFileName(icon));
            return false;
        }

        if(!IsValidPath(icon)) {
            dbgprintf("Error: The '%s' has an icon \"%s\" with an invalid path.", debugTerm, EplFile_GetFileName(icon));
            return false;
        }

        // Validate license
        // const license = iconPack.GetLicenseFullPath();
        // if(!license.empty()) {
        //     const licenseFileName = iconPack.GetLicense();
        //     const licenseMetaData = isFileObject ? Folder_FileExists(iconPackFiles, licenseFileName) : await EplFile_FileExists(license);

        //     if(!licenseMetaData) {
        //         // if(!await EplFile_FileExists(license)) {
        //         dbgprintf("Error: The %s has a license \"%s\" that does not exist.", debugTerm, EplFile_GetFileName(license));
        //         return false;
        //     }

        //     if(!IsValidPath(license)) {
        //         dbgprintf("Error: The '%s' has a license \"%s\" with an invalid path.", debugTerm, EplFile_GetFileName(license));
        //         return false;
        //     }
        // }

        // Validate the icons.json
        const iconsMetadataPath = iconPack.GetIconsMetadataFullPath();
        // const iconMetaData = isFileObject ? await GetPathForComponent(inPathMulti, 'icons.json') : await EplFile_FileExists(iconsMetadataPath);
        const iconMetaData = isFileObject ? Folder_FileExists(iconPackFiles, 'icons.json') : await EplFile_FileExists(iconsMetadataPath);
        if(!iconMetaData) {
            // if(iconsMetadataPath.empty() || !EplFile_FileExists(iconsMetadataPath)) {
            dbgprintf("Error: The %s has an icons.json file that does not exist.", debugTerm);
            return false;
        }

        if(!IsValidPath(iconsMetadataPath)) {
            dbgprintf("Error: The '%s' has a icons.json file with an invalid path.", debugTerm);
            return false;
        }

        // const manifestPath = isFileObject ? await GetManifestFromFilePathJS(inPathMulti) : GetIconsMetadataFullPath(inPath);
        let iconsMetadataSupportedResult = {result: kESDIconPackSupportedResult_Supported}; // ;
        const iconsMetadata = await ESDIconPackParser.CreateIconsMetadataFromPath(iconsMetadataPath, iconsMetadataSupportedResult, iconMetaData);
        if(iconsMetadataSupportedResult.result != kESDIconPackSupportedResult_Supported) {
            dbgprintf("Error: The icons.json file doesn't contain a valid json.");
            return false;
        }

        // Check if all the icons in the json exists on disk
        const allKnownIconPaths = [];
        for(let iconMetadata of iconsMetadata) {

            if(iconMetadata.path.empty()) {
                dbgprintf("Error: Missing path in icons.json file.");
                return false;
            }

            allKnownIconPaths.push(iconMetadata.path);

            if(iconMetadata.name.empty()) {
                dbgprintf("Error: Missing name in icons.json file for '%s'.", iconMetadata.path);
                return false;
            }

            const iconMetadataFullPath = isFileObject ? iconMetadata.path : iconPack.GetFullPathForIcon(iconMetadata.path);
            const fileExists = isFileObject ? Folder_FileExists(iconsFiles, iconMetadataFullPath) : await EplFile_FileExists(iconMetadataFullPath);

            // dbgprintf(`checking ${iconMetadataFullPath} ${!!fileExists ? 'ok' : 'failed'}`);

            if(!fileExists) {
                // if(!await EplFile_FileExists(iconMetadataFullPath)) {
                dbgprintf("Error: The file '%s' defined in the icons.json file does not exist.", iconMetadataFullPath.c_str());
                return false;
            }

            if(!IsValidPath(iconMetadataFullPath)) {
                dbgprintf("Error: The file '%s' defined in the icons.json file has an invalid path.", iconMetadataFullPath.c_str());
                return false;
            }

            // Check if the tags are valid
            for(let tag of iconMetadata.tags) {
                if(tag.find(", ") != npos) {
                    dbgprintf("Error: The tag '%s' in the icons.json file shouldn't be a list of strings. Please use instead a json array like '\"tags\": [\"tag1\", \"tag2\", \"tag3\"]'", tag.c_str());
                    return false;
                }
            }

            if('.gif' === EplFile_GetExtension(iconMetadata.path)) {
                const iconName = iconMetadata.path.replace(".gif", ".png");
                const inIconsPath = isFileObject ? await GetFolder(inPathMulti, 'icons') : iconPack.GetFullPathForIcon(iconName);
                const complementaryPngExists = isFileObject ? await GetPathForComponent(inIconsPath, iconName) != null : await EplFile_FileExists(inIconsPath);
                if(!complementaryPngExists) {
                    dbgprintf("Error: The GIF file '%s' should have a complementary  '%s' .", iconMetadata.path, iconName);
                }
            }
        }

        // Checked if all the icons on disk exist in the json
        const iconsFolder = iconPack.GetIconsFolderFullPath();
        dbgprintf(`Found ${allKnownIconPaths.length} icons in ${iconsFolder}`);
        
        if(!previewImagesFolder) {
            dbgprintf("Note: No 'previews' folder was found. It is not required, but allows users to get an idea of what's in the iconpack.");
        }

    } catch(error) {
        dbgprintf("Error: Validation failed...  %s", createErrorMessage(error));
        // openConsole(true)¥;
        return false;

    }
    // if(!CheckFilesFromFolderExistInIconsJson(iconsFolder, "", allKnownIconPaths)) {
    //     return false;
    // }

    return true;

};

// MARK: - Upload



// MARK: ESDICONPACK
//  return new ESDIconPackC(inUUID, version, name, author, url, icon, license, inFullPath);
export class ESDIconPackC {
    constructor (...options) {
        const [UUID, Version, Name, Author, URL, Icon, License, manifestFullPath] = [...options];

        this.manifest = Object.assign({}, {
            Version: '1.2.3',
            Name: 'MyIconPack',
            Author: 'Andy Fuchs',
            URL: 'https://elgato.com',
            UUID: 'com.elgato.iconPack'
        }, {
            UUID, Version, Name, Author, URL, Icon, License
        });

        this.mIconPath = Icon || '';
        this.mFullPath = manifestFullPath || '';
        this.mLicensePath = License;
    }

    get version() {
        return this.manifest.Version;
    }

    get url() {
        return this.manifest.URL;
    }

    // C++ wrappers
    GetVersion() {
        return this.manifest.Version;
    }

    GetName() {
        return this.manifest.Name;
    }

    GetAuthor() {
        return this.manifest.Author;
    }

    GetURL() {
        return this.manifest.URL;
    }

    GetIcon() {
        return this.manifest.Icon;
    }

    GetLicense() {
        return this.manifest.License;
    }
    GetUUID() {
        return this.manifest.UUID;
    };

    // GetPathFromFileObject() {
    //     if(typeof mFullPath === 'object') {
    //         readFileEntry();
    //     }
    // }

    GetIconFullPath() {
        if(!this.mIconPath.empty() && !this.mFullPath.empty()) {
            const fullPath = EplFile_AddPathComponent(this.mFullPath, this.mIconPath);
            return fullPath;
        }

        return "";
    }

    GetLicenseFullPath() {
        if(!this.mLicensePath.empty() && !this.mFullPath.empty()) {
            const fullPath = EplFile_AddPathComponent(this.mFullPath, this.mLicensePath);
            return fullPath;
        }

        return "";
    }

    GetIconsMetadataFullPath() {
        if(!this.mFullPath.empty()) {
            const fullPath = EplFile_AddPathComponent(this.mFullPath, "icons.json");
            return fullPath;
        }

        return "";
    }

    GetIconsFolderFullPath() {
        if(!this.mFullPath.empty()) {
            const fullPath = EplFile_AddPathComponent(this.mFullPath, "icons");
            return fullPath;
        }

        return "";
    }


    GetFullPathForIcon(inIconPath) {
        let fullPath = this.GetIconsFolderFullPath();
        if(!fullPath.empty() && !inIconPath.empty()) {
            fullPath = EplFile_AddPathComponent(fullPath, inIconPath);
            return fullPath;
        }

        return "";
    }
}




export function test() {
    /*
    const uuid = 'com.elgato.test';
    const inPath = '.';
    const manifestPath = 'manifest.json';
    const supportedResult = 0;
    const iconPack = ESDIconPackParser.CreateIconPackFromPath(uuid, manifestPath, manifestPath, supportedResult);

    const debugTerm = GetDebugTerm(kESDObjectType_IconPack);

    if(iconPack == NULL) {
        dbgprintf("Error: The manifest.json file doesn't contain a valid json.");
        return false;
    }

    if(iconPack.GetVersion().empty()) {
        dbgprintf("Error: The %s has an invalid version. Please add a valid \"Version\" property to the manifest.json file.", debugTerm);
        return false;
    }

    const arr = ["com.elgato.mama", "de.io.smm"];
    console.log('GetUUID', arr.map(e => `${e} - ${iconPack.GetUUID(e)}`));
    console.log('IsValidURI', arr.map(e => `${e} - ${IsValidURI(e)}`));
    */
    console.log('------- TEST --------');
    Validate(kESDObjectType_IconPack, 'com.elgato.blue.sdIconPack');
}

// test();



// setTimeout(() => {
//     let ipck = '../com.elgato.red.sdIconPack';
//     console.log("VALIDATE");
//     Validate(kESDObjectType_IconPack, ipck).then(success => {
//         dbgprintf(success ? 'Validation succeeded for  %s' : 'Error while validating iconPack  %s', ipck, !success);
//     });

//     // let ipck2 = 'com.elgato.blue.sdIconPack';
//     // Validate(kESDObjectType_IconPack, ipck2).then(success => {
//     //     dbgprintf(success ? 'Validation succeeded for  %s' : 'Error while validating iconPack  %s', ipck2, !success);
//     // });

// }, 100);


